/* eslint-disable no-unused-vars */
import { createContext, useContext, ReactNode } from "react";
import Teachr from "../../Objects/models/Teachr";
import { DeclarationStep, DeclarationV2State } from "./types";

export interface DeclarationV2ContextType {
    teachr: Teachr;
    state: DeclarationV2State;
    /** Fusionne un morceau d'état (persisté aussitôt). */
    update: (patch: Partial<DeclarationV2State>) => void;
    /** Remet l'assistant à zéro et revient à l'accueil. */
    reset: () => void;
    /** Change d'écran (et remonte la page). */
    goTo: (step: DeclarationStep) => void;
    /** Élèves actifs du prof, paginés et filtrés côté serveur. */
    clients: any[];
    totalClients: number;
    currentPage: number;
    pageSize: number;
    search: string;
    setSearch: (value: string) => void;
    setPage: (page: number) => void;
    setPageSize: (size: number) => void;
    clientsLoading: boolean;
}

const DeclarationV2Context = createContext<DeclarationV2ContextType | null>(null);

export const useDeclarationV2 = (): DeclarationV2ContextType => {
    const context = useContext(DeclarationV2Context);
    if (!context) {
        throw new Error("useDeclarationV2 doit être utilisé à l'intérieur de DeclarationV2Provider");
    }
    return context;
};

export const DeclarationV2Provider = ({ value, children }: { value: DeclarationV2ContextType; children: ReactNode }) => (
    <DeclarationV2Context.Provider value={value}>{children}</DeclarationV2Context.Provider>
);
